const DOMAIN_AFFILIATE_MAP: Record<string, string> = {
  'chat.inaom.co.kr': 'INAOM',
  'chat.inamct.co.kr': 'INAMCT',
  'chat.inacorp.co.kr': 'INACORP',
};

export function getDefaultAffiliateByDomain(): string | null {
  const hostname = window.location.hostname;
  return DOMAIN_AFFILIATE_MAP[hostname] ?? null;
}
